import { apiGet, apiPost } from './client'

export type LandMissionState = 'LOCKED' | 'AVAILABLE' | 'STARTED' | 'COMPLETED'

export type LandMission = {
  id: number
  code: string
  title: string
  description: string | null
  requiredPermission: string
  locked: boolean
  state: LandMissionState
}

export type LandMissionAction = {
  missionId: number
  state: 'STARTED' | 'COMPLETED'
  persisted: boolean
  startedAt?: string | null
  completedAt?: string | null
}

export type LandProgress = {
  missions: LandMissionAction[]
}

function missionPath(missionId: number, action: 'start' | 'complete') {
  if (!Number.isSafeInteger(missionId) || missionId <= 0) {
    throw new RangeError('missionId must be a positive safe integer')
  }

  return `/api/land/missions/${missionId}/${action}`
}

export function listLandMissions() {
  return apiGet<LandMission[]>('/api/land/missions')
}

export function startLandMission(missionId: number) {
  return apiPost<LandMissionAction>(missionPath(missionId, 'start'), undefined)
}

export function completeLandMission(missionId: number) {
  return apiPost<LandMissionAction>(missionPath(missionId, 'complete'), undefined)
}

export function getLandProgress() {
  return apiGet<LandProgress>('/api/land/progress')
}
